import React, { useEffect, useState } from 'react'
import "./C2.css";
import Product from "./Product"
import Carousel from 'react-bootstrap/Carousel'
import axios from './axios';
import ProductSkeleton from './components/skeleton/ProductSkeleton';

function C2() {
    const [dairy,setDairy]=useState([])
    const [bakery,setBakery]=useState([])
    const [cake,setCake]=useState([])
    const skeleton=[1,2,3,4]

    useEffect(()=>{
        axios({
            url:'/products/category/dairy',
            method:'get'
        }).then(res => setDairy(res.data)).catch(err => console.log("eee",err))
        axios({
            url:'/products/category/bread',
            method:'get'
        }).then(res => setBakery(res.data)).catch(err => console.log("eee",err))
        axios({
            url:'/products/category/cake',
            method:'get'
        }).then(res => setCake(res.data)).catch(err => console.log("eee",err))
    },[])
    return (
        <section className="contaier">
             <Carousel>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NPL2577-1200x300-25thjul.jpg"
                    alt="First slide"
                    />
                    {/* <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NNP3391-1200x300-25thjul.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2805-NPL2807.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2972.jpg"
                    alt="4 slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL3027-29-31-11aug20.jpg"
                    alt="5 slide"
                    />
                </Carousel.Item>
            </Carousel>
            <section className="container-fluid">
            <h5 className="ml-5 mt-4">Dairy </h5>           
            <article className="row">
                {
                    dairy.length>0?dairy.map((d,i)=>
                        <article className="col-md-3" key={i}>
                            <Product
                                id={d._id}
                                title={d.title}
                                price={d.price}
                                rating={d.rating}
                                image={d.image}
                                stock={d.stock}
                                />
                        </article>
                    )
                    :
                    skeleton.map((s,i)=>
                        <article className='col-md-3 col-sm-4' key={i}>
                            <ProductSkeleton />
                        </article>
                   )
                }
            </article>

            <h5 className="ml-5 mt-4">Bakery</h5>           
            <article className="row">  
                    {
                        bakery.length>0?
                        bakery.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            />
                              </article>
                        ):
                        skeleton.map((s,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                                <ProductSkeleton />
                            </article>
                       )
                    }
            </article>
            
            <h5 className="ml-5 mt-4">Cakes</h5> 
            <article className="row">
                {
                    cake.length>0?cake.map((d,i)=>
                        <article className="col-md-3" key={i}>
                            <Product
                                id={d._id}
                                title={d.title}
                                price={d.price}
                                rating={d.rating}
                                image={d.image}
                                stock={d.stock}
                                />
                        </article>
                    )
                    :
                    skeleton.map((s,i)=>
                        <article className='col-md-3 col-sm-4' key={i}>
                            <ProductSkeleton />
                        </article>
                   )
                }
            </article>
            </section>
           
            
        </section>
    )
}

export default C2
